var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDsl = function SvgDsl(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF8",
    d: "M14 15.4H7v7h7v2.8H4.2v-14H7v1.4h7zM8.4 2.8v2.8H2.8V2.8zM11.2 0H0v8.4h11.2zm14 12.6v2.8h-5.6v-2.8zM28 9.8H16.8v8.4H28zm-2.8 12.6v2.8h-5.6v-2.8zm2.8-2.8H16.8V28H28z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDsl);
export { ForwardRef as ReactComponent };